import { lazy } from '../../shared/deployment';

// Search queries:
export const SearchQueryToggle = lazy(() => import('./SearchQueryToggle'));
export const SearchQueryPhrase = lazy(() => import('./SearchQueryPhrase'));
export const SearchQueryFilter = lazy(() => import('./SearchQueryFilter'));
